import { convertDateToUTC, DATE_PATTERN_DD_MMM_YYYY_DASH } from "../../helper/helper";
import { Organisation } from "../organisation/OrganisationModelV2";
import { Person } from "../person/Person";
import { ContractInterface } from "./ContractInterface";
import { buildReceiptPhotos, ContractPhoto } from "./ContractPhoto";
import { Harvest } from "./Harvest";
import { SaleStatement } from "./SaleStatement";

// Define or import ContractInterface
export class ContractNAM implements ContractInterface {
    contract_id: number;
    status: string;
    market_day: string;
    harvests: Harvest[];
    statement: SaleStatement;
    agent_person: Person;
    buyer: Organisation;
    agent: Organisation;

    constructor(data: any = {}) {
        this.contract_id = data.contract_id || '';
        this.status = data.status || '';
        this.market_day = data.market_day || '';
        this.harvests = data.harvests?.map((harvest: any) => Harvest.build(harvest));
        this.statement = SaleStatement.buildForName(data.statement || {});
        this.agent_person = Person.build(data.agent_person);
        this.buyer = Organisation.build(data.buyer);
        this.agent = Organisation.build(data.agent);
    }
    getType(): string {
        return "NAM";
    }

    static build(d: any): ContractNAM {
        return new ContractNAM(d)
    }

    harvestPhotos(): ContractPhoto[] {
        return this.harvests?.filter(h => h.photos)?.flatMap(h => h.photos) ?? [];
    }
    receiptPhotos(): ContractPhoto[] {
        return buildReceiptPhotos(this.getBuyerSaleStatement()?.photos)
    }
    getTotal(): number | undefined {
        return this.statement?.total
    }
    getHarvest(): Harvest[] {
        return this.harvests
    }
    getMargetDay(): string {
        return convertDateToUTC(this.market_day, DATE_PATTERN_DD_MMM_YYYY_DASH)
    }
    getBuyerSaleStatement(): SaleStatement {
        return this.statement
    }

    getBuyer(): Organisation {
        return this.buyer
    }
    getPersonTransporter(): Person | undefined {
        return undefined
    }
    getPersonAgent(): Person | undefined {
        return this.agent_person
    }
    getAgent(): Organisation | undefined {
        return this.agent
    }
    getId(): number {
        return this.contract_id
    }
    getStatus(): string {
        return this.status
    }
}